/**
 *预约校牌数据管理/预约心电贴数据管理列表查询
 */
import request from '@/utils/request';
import { getToken } from '@/utils/auth';
import ENVIRONMENT from '@/utils/environment';

// 导出预约记录
export function exportSubExcel(options) {
  let url = '';
  url = `${ENVIRONMENT.BASE_API}/op/subscribe/exportSubExcel?`;
  for (var key in options) {
    url += `${key}=${options[key]}&`;
  }
  url = url.substring(0, url.lastIndexOf('&'));
  return url + `&token=${getToken()}`;
}
// 导出核销校牌或者心电贴数据
export function exportDesExcel(options) {
  let url = '';
  url = `${ENVIRONMENT.BASE_API}/op/subscribe/exportDesExcel?`;
  for (var key in options) {
    url += `${key}=${options[key]}&`;
  }
  url = url.substring(0, url.lastIndexOf('&'));
  return url + `&token=${getToken()}`;
}
/**
* 分页查询社区列表
subscribeType 预约类型 1-预约校牌 2-预约心电贴
*/
export function get_subscribe_pagelist(options) {
  return request({
    url: `/op/subscribe/`,
    method: 'get',
    params: options
  });
}
// 分页查询校牌或者核销列表
export function get_sdestoryList(options) {
  return request({
    url: `/op/subscribe/destoryList`,
    method: 'get',
    params: options
  });
}
// 设置每日预约人数
export function set_setSubscribeNum(options) {
  return request({
    url: `/op/subscribe/setSubscribeNum`,
    method: 'post',
    data: options
  });
}
// 查询每日预约人数
export function getConfig(options) {
  return request({
    url: `/op/subscribe/getConfig`,
    method: 'get'
  });
}

// 查询预约人数列表
export function getRecordList(options) {
  return request({
    url: `/op/subscribe/pageList`,
    method: 'get',
    params: options
  });
}

// 保存领取人数
export function setSubscribeNum(data) {
  return request({
    url: `/op/subscribe/setSubscribeNum`,
    method: 'post',
    data
  });
}

// 删除
export function deleteSubNum(id) {
  return request({
    url: `/op/subscribe/deleteSubNum/${id}`,
    method: 'delete'
  });
}
// 修改
export function updateRow(id, data) {
  return request({
    url: `/op/subscribe/updateRemark/${id}`,
    method: 'POST',
    data
  });
}

// 获取启用社区
export function getCommunity() {
  return request({
    url: `/op/street/getCommunity`,
    method: 'get'
  });
}

// ------------心电贴数据录入
// 分页查询校牌或者核销列表
export function get_sdestoryList_Register(options) {
  return request({
    url: `/op/detoryHeart/`,
    method: 'get',
    params: options
  });
}
// 添加
export function registerAdd(data) {
  return request({
    url: `/op/detoryHeart/addHeart`,
    method: 'POST',
    data
  });
}
// 添加
export function registerUpdate(id, data) {
  return request({
    url: `/op/detoryHeart/` + id,
    method: 'POST',
    data
  });
}

// 导出列表
export function exportsTable(options) {
  return request({
    url: `/op/detoryHeart/exportHeart`,
    method: 'get',
    responseType: 'blob',
    params: options
  });
}
// 导入
export function listImport() {
  return `${ENVIRONMENT.BASE_API}/op/detoryHeart/improtHeartExcel?token=${getToken()}`;
}

export function usermanagerExcelTemplate() {
  return `${ENVIRONMENT.BASE_API}/op/detoryHeart/excelHeartTemplate?token=${getToken()}`;
}
